module.exports = __webpack_public_path__ + "static/media/delicious.5271d071.svg";